import { Box } from '@mui/material';
import { CheckmarkOutlinedIconBig, SortingArrowLeftIcon } from '@synergy/theme-next';
import { PoolButton } from '@synergy/components-next';
import { PoolFormattedMessage } from '@synergy/components-next';
import { ReactElement } from 'react';
import { useNavigate } from 'react-router';

import { EmptyState } from '../../../components/empty-state/empty-state';
import { EmptyStateActions } from '../../../components/empty-state/empty-state-actions';
import { EmptyStateContent } from '../../../components/empty-state/empty-state-content';
import { EmptyStateTitle } from '../../../components/empty-state/empty-state-title';
import { openInquiryModal } from '../../../store/single-inquiry-actions';
import { useAppDispatch } from '../../../../store/store';

export const ShoppingCartSubmitInquiry = (): ReactElement => {
    const navigate = useNavigate();
    const dispatch = useAppDispatch();

    const handleBackToShopClick = (): void => {
        navigate('/');
    };

    const handleClickFurtherInquiries = (): void => {
        dispatch(openInquiryModal());
    };

    return (
        <Box sx={{ py: 22, margin: 'auto' }}>
            <EmptyState icon={<CheckmarkOutlinedIconBig fontSize="inherit" />}>
                <EmptyStateTitle>
                    <PoolFormattedMessage id="app.cart.submit.inquiry.title" />
                </EmptyStateTitle>
                <EmptyStateContent>
                    <PoolFormattedMessage id="app.cart.submit.inquiry.content" />
                </EmptyStateContent>
                <EmptyStateActions>
                    <PoolButton variant="contained" onClick={handleClickFurtherInquiries}>
                        <PoolFormattedMessage id="app.cart.submit.inquiry.furtherInquiries" />
                    </PoolButton>
                    <PoolButton variant="outlined" startIcon={<SortingArrowLeftIcon />} onClick={handleBackToShopClick}>
                        <PoolFormattedMessage id="app.empty.button.backToShop" />
                    </PoolButton>
                </EmptyStateActions>
            </EmptyState>
        </Box>
    );
};
